{
  "tabs": {
    "lintTriage": "Triaje de lint",
    "testFailures": "Pruebas fallidas",
    "playwrightTests": "Pruebas de Playwright"
  },
  "fixWithClaudeDialog": {
    "title": "Corregir con Claude - {{fileName}}",
    "runningInBackground": "Ejecutándose en segundo plano (puede cerrar este diálogo)",
    "startingClaude": "Iniciando Claude...",
    "fileChangesAccordion": "Cambios en archivos (git diff)",
    "noChangesDetected": "No se detectaron cambios",
    "status": {
      "success": "✅ ¡Corrección completada con éxito!",
      "cancelled": "⚠️ Corrección cancelada",
      "error": "❌ Corrección fallida (ver arriba)"
    },
    "buttons": {
      "cancel": "Cancelar",
      "clear": "Borrar",
      "close": "Cerrar"
    }
  },
  "playwrightTests": {
    "title": "Pruebas de Playwright",
    "loading": "Cargando pruebas de Playwright...",
    "testCount": "{{count}} pruebas · Est. {{duration}}",
    "buttons": {
      "retry": "Reintentar",
      "runningTests": "Ejecutando pruebas...",
      "runAllTests": "Ejecutar pruebas"
    },
    "alerts": {
      "noTestsFound": "No se encontraron resultados de Playwright. Haz clic en \"Ejecutar todas las pruebas\" para ejecutarlas.",
      "runningTests": "Ejecutando pruebas de Playwright... Esto puede tardar unos minutos."
    },
    "execution": {
      "started": "Ejecución de prueba iniciada ({{processId}})",
      "completed": "Ejecución de prueba completada con código {{code}}"
    }
  },
  "fileCard": {
    "errorCounts": {
      "eslint": "ESLint",
      "typescript": "TypeScript",
      "total": "total"
    },
    "buttons": {
      "viewErrors": "Ver errores",
      "copyAll": "Copiar todo para Claude",
      "fixAllWithClaude": "Corregir todo con Claude",
      "viewProgress": "Ver progreso...",
      "fixed": "Listo ✓",
      "fixFailed": "Corrección fallida ✗"
    }
  },
  "fileErrorsView": {
    "buttons": {
      "backToFiles": "Volver a Archivos",
      "copyAllErrors": "Copiar los {{count}} errores",
      "openInVSCode": "Abrir en VSCode",
      "copyIndividual": "Copiar individuo"
    },
    "errorCounts": {
      "eslint": "ESLint",
      "typescript": "TypeScript",
      "total": "total",
      "line": "Línea {{number}}"
    },
    "snackbar": {
      "copiedAll": "¡Se copiaron los {{count}} errores para Claude!",
      "copiedLine": "Copiado error de la línea {{line}}"
    }
  },
  "playwrightTestDetail": {
    "buttons": {
      "backToTests": "Volver a Pruebas",
      "viewScreenshots": "Ver capturas de pantalla ({{count}})",
      "viewVideos": "Ver Videos ({{count}})",
      "updateSnapshots": "Actualizar capturas",
      "updating": "Actualizando...",
      "fixWithClaude": "Corregir con Claude"
    },
    "labels": {
      "errorMessage": "Mensaje de error:"
    },
    "messages": {
      "testPassed": "¡Esta prueba se completó correctamente!",
      "snapshotsUpdated": "Instantáneas actualizadas correctamente",
      "snapshotsFailed": "No se pudieron actualizar las capturas. Revisa la consola para más detalles.",
      "error": "Error: {{message}}",
      "claudeComingSoon": "¡Integración con Claude fix disponible pronto!"
    }
  }
}
